import sberpayLogo from './sberpayLogo.svg';
import tpayLogo from './tpayLogo.svg';
import upiLogo from './upi.png';
import momoLogo from './momo.png';
import gpayLogo from './gpay.png';
import phonepeLogo from './phonepe.svg';
import paytmmpLogo from './paytmmp.png';
import {Typography} from '@mui/material';
import React from 'react';

const vertical = {zIndex: 10, display: 'flex', gap: 1, alignItems: 'center', flexDirection: 'column'}
const horizontal = {zIndex: 10, display: 'flex', gap: 12, alignItems: 'center'}

export const deepLinksButtons = {
  phonepe: (props) => {
    return (
      <div style={props.variant === 'vertical' ? vertical : horizontal}>
        <div
          style={{
            height: 32,
            width: 32,
            padding: 2,
            borderRadius: '50%',
            background: '#fff',
          }}
        >
          <div
            style={{
              background: `url("${phonepeLogo}") no-repeat center center`,
              height: 32,
              width: 32,
              borderRadius: '50%',
              backgroundSize: 'contain',
            }}
          />
        </div>
        <Typography style={{color: '#FFF', fontWeight: 500, textTransform: 'initial'}}>
          PhonePe
        </Typography>
      </div>
    )
  },
  gpay: (props) => {
    return (
      <div style={props.variant === 'vertical' ? vertical : horizontal}>
        <div
          style={{
            height: 32,
            width: 32,
            padding: 2,
            borderRadius: '50%',
            background: '#fff',
          }}
        >
          <div
            style={{
              background: `url("${gpayLogo}") no-repeat center center`,
              height: 32,
              width: 32,
              borderRadius: '50%',
              backgroundSize: 'contain',
            }}
          />
        </div>
        <Typography style={{color: '#FFF', fontWeight: 500, textTransform: 'initial'}}>
          GPay
        </Typography>
      </div>
    )
  },
  paytmmp: (props) => {
    return (
      <div style={props.variant === 'vertical' ? vertical : horizontal}>
        <div
          style={{
            height: 32,
            width: 32,
            padding: 2,
            borderRadius: '50%',
            background: '#fff',
          }}
        >
          <div
            style={{
              background: `url("${paytmmpLogo}") no-repeat center center`,
              height: 32,
              width: 32,
              borderRadius: '50%',
              backgroundSize: 'contain',
            }}
          />
        </div>
        <Typography style={{color: '#FFF', fontWeight: 500, textTransform: 'initial'}}>
          Paytm
        </Typography>
      </div>
    )
  },
  momo: (props) => {
    return (
      <div style={{zIndex: 10, display: 'flex', gap: 12, alignItems: 'center'}}>
        <div
          style={{
            height: 32,
            width: 32,
            padding: 2,
            borderRadius: '50%',
            background: '#fff',
          }}
        >
          <div
            style={{
              background: `url("${momoLogo}") no-repeat center center`,
              height: 32,
              width: 32,
              borderRadius: '50%',
              backgroundSize: 'contain',
            }}
          />
        </div>
        <Typography style={{color: '#fff'}}>
          Pay MoMo
        </Typography>
      </div>
    )
  },
  upi: (props) => {
    return (
      <div style={props.variant === 'vertical' ? vertical : horizontal}>
        <div
          style={{
            height: 32,
            width: 32,
            padding: 2,
            borderRadius: '50%',
            background: '#fff',
          }}
        >
          <div
            style={{
              background: `url("${upiLogo}") no-repeat center center`,
              height: 32,
              width: 32,
              borderRadius: '50%',
              backgroundSize: 'contain',
            }}
          />
        </div>
        <Typography style={{color: '#fff'}}>
          {props.variant === 'vertical' ? 'UPI' : 'Pay UPI'}
        </Typography>
      </div>
    )
  },
  sberpay: (props) => {
    return (
      <div style={{zIndex: 10, display: 'flex', gap: 12, alignItems: 'center'}}>
        <div
          style={{
            background: `url("${sberpayLogo}") no-repeat center center`,
            height: 32,
            width: 32,
            backgroundSize: 'contain',
          }}
        />
        <Typography style={{color: '#fff'}}>
          sberpay
        </Typography>
      </div>
    )
  },
  tpay: (props) => {
    return (
      <div style={{zIndex: 10, display: 'flex', gap: 12, alignItems: 'center'}}>
        <div
          style={{
            background: `url("${tpayLogo}") no-repeat center center`,
            height: 64,
            width: 64,
            backgroundSize: 'contain',
          }}
        />
      </div>
    )
  }
}
